import { AUTH_ROUTE_PATH } from "./auth-router.constant";
import { USERS_ROUTE_PATH } from "./users-router.constant";
import { SUBSCRIPTION_ROUTE_PATH } from "./subscription-router.constant";
import { MANUAL_CATEGORY_ROUTE_PATH } from "./manual-category-router.constant";

export const ROUTE_PATH = {
  ...USERS_ROUTE_PATH,
  ...AUTH_ROUTE_PATH,
  ...SUBSCRIPTION_ROUTE_PATH,
  ...MANUAL_CATEGORY_ROUTE_PATH,
};
